import React from 'react'
import { OrderType } from '../../tableHelpers/tableConfig'
import { BalanceRowType } from './TableBalance'
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from '@mui/material'
import { visuallyHidden } from '@mui/utils';
import { isIterableArray, toFormatPrice } from '../../../utils/utils'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import TableEmptyRows from '../../tableHelpers/TableEmptyRows'

interface BalanceHeadCell {
    id: keyof BalanceRowType;
    dataIndex: keyof BalanceRowType,
    label: string;
    align: 'inherit' | 'left' | 'center' | 'right' | 'justify';
    sorting?: boolean,
    className?: string,
    render?: any
}

type PropsType = {
    isLoadingTable: boolean,
    rows: BalanceRowType[],
    visibleRows: BalanceRowType[],
    orderBy: keyof BalanceRowType,
    order: OrderType,
    service_id: any,
    handleRequestSort: any,
}
const TableBalanceDumb = (props: PropsType): JSX.Element => {

    const { t } = useTranslation()
    const {
        isLoadingTable,
        rows,
        visibleRows,
        orderBy,
        order,
        service_id,
        handleRequestSort
    } = props

    const { param_contract_id } = useParams()
    // ______SERVICE COLORS

    const textSearchService = service_id === 1 ? 'bg-orange-100' : service_id === 2 ? 'bg-blue-100' : 'bg-gray-200'
    const hoverRowService = service_id === 1 ? 'hover:!bg-orange-50' : service_id === 2 ? 'hover:!bg-blue-100' : 'hover:!bg-gray-200'
    const sortIconService = service_id === 1 ? 'svg-sort-orange' : service_id === 2 ? 'svg-sort-blue' : ''


    function TableHeadComponent() {
        const createSortHandler = (property: keyof BalanceRowType) => (event: React.MouseEvent<unknown>) => {
            handleRequestSort(event, property);
        };
        return (
            <TableHead className='table-head-border border-none font-sans'>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={'normal'}
                            sx={{ paddingBottom: '0px !important', paddingTop: '0px !important', border: 'none' }}
                            className={`!font-sans ${headCell.className}`}
                        >
                            {
                                headCell.sorting ?
                                    <TableSortLabel
                                        active={orderBy === headCell.id}
                                        direction={orderBy === headCell.id ? order : 'asc'}
                                        onClick={createSortHandler(headCell.id)}
                                        className={`${sortIconService} text-base !text-gray text-nowrap`}
                                    >
                                        {t(headCell.label)}
                                        {orderBy === headCell.id ? (
                                            <Box component="span" sx={visuallyHidden} >
                                                <>
                                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                </>
                                            </Box>
                                        ) : null}
                                    </TableSortLabel>
                                    :
                                    <span className='text-base font-normal !text-gray-600 whitespace-nowrap'>
                                        {t(headCell.label)}
                                    </span>
                            }
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }
    function TableRowsRender({ cells, row }: { cells: BalanceHeadCell[], row: BalanceRowType }) {
        return (
            <>
                {
                    cells.map((cell, index) => {
                        const key = cell.dataIndex
                        return (
                            <TableCell
                                key={cell.dataIndex}
                                align={cell.align}
                                sx={{
                                    border: 'none', lineHeight: '120%',
                                    borderTopRightRadius: index === cells.length - 1 ? 16 : 0,
                                    borderBottomRightRadius: index === cells.length - 1 ? 16 : 0,
                                    borderTopLeftRadius: index === 0 ? 16 : 0,
                                    borderBottomLeftRadius: index === 0 ? 16 : 0,
                                }}
                                padding={'normal'}
                                className='!font-sans !text-gray-700 !text-[16px]'
                            >
                                {
                                    cell.render ?
                                        cell.render(row[key], row)
                                        :
                                        row[key]
                                }
                            </TableCell>
                        )
                    })
                }
            </>
        )
    }

    const headCells: BalanceHeadCell[] = [
        {
            dataIndex: 'date', // какое поле в таблице
            id: 'date_sort', // какое поле в сортировке
            align: 'left',
            sorting: true,
            label: 'contract_page.view_balances_date',
            className: 'w-[25%]',
            render: (item: any, record?: any) => (
                <span className='text-gray-700'>
                    {item}
                </span>
            )
        },
        {
            dataIndex: 'amount_cl',
            id: 'amount_cl',
            sorting: true,
            align: 'left',
            label: `contract_page.view_balances_sum`,
            className: 'w-[20%]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {item ? toFormatPrice(item) : toFormatPrice(0)}
                </div>
            )
        },
        {
            dataIndex: 'balance_cl',
            id: 'balance_cl',
            sorting: true,
            align: 'left',
            label: `contract_page.view_balances_added_summ`,
            className: 'w-[20%]',
            render: (item: any, record: any) => (
                <div className={`text-gray-700`}>
                    {item ? toFormatPrice(item) : toFormatPrice(0)}
                </div>
            )
        },
        {
            dataIndex: 'action', // какое поле в таблице
            id: 'action', // какое поле в сортировке
            align: 'left',
            sorting: true,
            label: 'contract_page.view_balances_text_action',
            className: 'w-[35%]',
            render: (item: any, record?: any) => (
                <span className='text-gray-700'>
                    {item}
                </span>
            )
        },
    ];

    return (
        <div>
            <TableContainer className='hidden tab:block'>
                <Table
                    sx={{
                        borderCollapse: 'separate',
                        borderSpacing: '0 16px',
                    }}
                    size={'medium'}
                >
                    <TableHeadComponent />
                    <TableBody>
                        {
                            isIterableArray(visibleRows) ?
                                visibleRows.map((row, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            className={`  
                                                table-row-border
                                                service_id_${service_id}
                                                ${hoverRowService}
                                            `}
                                        >
                                            <TableRowsRender cells={headCells} row={row} />
                                        </TableRow>
                                    );
                                })
                                :
                                <TableEmptyRows isLoadingTable={isLoadingTable} />
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default TableBalanceDumb